import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addToLocationWarehouse: {
    description: 'Add to alternate location warehouse name',
    defaultMessage: 'Warehouse',
    id: 'QE0DPT',
  },
  addToLocationSelectWarehouse: {
    description: 'Add to alternate location select warehouse name',
    defaultMessage: 'Select a Warehouse',
    id: 'fTU4Kz',
  },
  addToLocationLocationLabel: {
    description: 'Add to alternate location select location label',
    defaultMessage: 'Location',
    id: 'wKfQoI',
  },
  inventoryLocationPickerSelectLocation: {
    description: 'Add to alternate location select location',
    defaultMessage: 'Select a Location',
    id: 'Vdeih3',
  },
  addToLocationLocationQuantity: {
    description: 'Add to alternate location quantity',
    defaultMessage: 'Quantity',
    id: 'heMqmR',
  },
  addToLocationLocationCostLabel: {
    description: 'Add to alternate location cost label',
    defaultMessage: 'Cost',
    id: 'gyDWCq',
  },
  addToLocationLocationNotesLabel: {
    description: 'Add to alternate location notes label',
    defaultMessage: 'Notes',
    id: '/RPKdM',
  },
  addToLocationLotLabel: {
    description: 'Add to alternate location lot label',
    defaultMessage: 'Lot ID',
    id: 'YqlLds',
  },
  addToLocationExpirationDateLabel: {
    description: 'Add to alternate location expiration date label',
    defaultMessage: 'Expiration Date',
    id: 'sqNGwt',
  },
});
